import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { onSortItemSelected } from '../../Actions/ProductFiltering.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { getColor } from '../../styling/mixins/colors';
import { text } from '../../styling/mixins/typography';
import RadioButton from '../Inputs/Radiobutton';

const StyledProductSortingList = styled.ul`
  padding: 2.4rem 1.6rem;
`;

const StyledSortingItem = styled.li`
  ${text('large')}
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  & div {
    margin: 0;
  }

  &:not(:last-child) {
    margin-bottom: 1.6rem;
  }

  &:hover .sort-radio-button {
    box-shadow: 0 0 0 1px ${getColor('primary')};
  }
`;

const StyledRadioButton = styled(RadioButton)`
  margin-right: 0;
`;

const ProductSortingRadios = () => {
  const dispatch = useDispatch();
  const { sortCriteria } =
    useTypedSelector((state) => state.productFiltering) ?? {};
  const selectedSortItem = sortCriteria?.sortItems.find((s) => s.selected);

  return (
    <StyledProductSortingList>
      {sortCriteria?.sortItems.map((item) => (
        <StyledSortingItem
          key={item.query}
          onClick={() => {
            dispatch(
              onSortItemSelected(
                sortCriteria?.sortItems.find((s) => s.query == item.query)
              )
            );
          }}
        >
          {item.name}{' '}
          <StyledRadioButton
            name="sort-radio"
            checked={selectedSortItem?.query == item.query}
            className="sort-radio-button"
          />
        </StyledSortingItem>
      ))}
    </StyledProductSortingList>
  );
};

export default ProductSortingRadios;
